import { AreaOfUseAdminEffects } from './area-of-use-admin.effect';

export const effects: any[] = [AreaOfUseAdminEffects];

export * from './area-of-use-admin.effect';
